import React from "react";
import { SERVER_IP } from "../../../static/server";

const ExamResultTable = ({ videoUrlList }) => {
  return (
    <div>
      <table className="exam-complete-table scroll-table">
        <thead>
          <tr>
            <th>문항</th>
            <th>유형</th>
            <th>응답상태</th>
            <th>제출된 파일</th>
            <th>비고</th>
          </tr>
        </thead>
        <tbody>
          {(!videoUrlList || videoUrlList?.length === 0) && (
            <tr>
              <td colSpan={5}>응시 데이터가 없습니다.</td>
            </tr>
          )}
          {videoUrlList?.map((urlData) => {
            return (
              <tr className="text-align-center" key={urlData.sn}>
                <td>{urlData.exam_number}</td>
                <td>녹화</td>
                <td>응시완료</td>
                <td>{urlData.exam_number}.webm</td>
                <td className="btn-td">
                  <button
                    className="video-watch-btn"
                    // onClick={() => window.open(`http://localhost:3001/${urlData.url}`)}
                    onClick={() => window.open(`${SERVER_IP}${urlData.url}`)}
                    // onClick={() => window.open(url.resolve(SERVER_IP, urlData.url))}
                  >
                    영상보기
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ExamResultTable;
